import React from 'react';
import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography, makeStyles, Box, Slider } from '@material-ui/core';
import AcceptanceRate from './AcceptanceRate';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
    justifyContent: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    }
  },
}));

const TestScores = ({ school }) => {
  const classes = useStyles();

  const readingData = school[
    'latest.admissions.sat_scores.25th_percentile.critical_reading'
  ]
    ? [
        school['latest.admissions.sat_scores.25th_percentile.critical_reading'],
        school['latest.admissions.sat_scores.75th_percentile.critical_reading'],
      ]
    : null;

  const mathData =
    [
      school['latest.admissions.sat_scores.25th_percentile.math'],
      school['latest.admissions.sat_scores.75th_percentile.math'],
    ] || null;

  const ACTData =
    [
      school['latest.admissions.act_scores.25th_percentile.cumulative'],
      school['latest.admissions.act_scores.75th_percentile.cumulative'],
    ] || null;

  const readingDataMarks = readingData && [
    { value: readingData[0], label: `${readingData[0]}` },
    { value: readingData[1], label: `${readingData[1]}` },
  ];

  const mathDataMarks = [
    { value: mathData[0], label: `${mathData[0]}` },
    { value: mathData[1], label: `${mathData[1]}` },
  ];

  const ACTDataMarks = [
    { value: ACTData[0], label: `${ACTData[0]}` },
    { value: ACTData[1], label: `${ACTData[1]}` },
  ];

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
          className={classes.summary}
        >
          <Typography variant="body2">
            {'Test Scores & Acceptance'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2">Test Scores</Typography>
                <Typography paragraph variant="caption">
                  Students who were admitted and enrolled typically had
                  standardized test scores in these ranges.
                </Typography>
                <Box display="flex" flexDirection="column">
                  {!readingData && (
                    <Typography variant="body2">
                      Data Not Available
                    </Typography>
                  )}
                  {readingData && mathData && ACTData && (
                    <>
                      <Typography
                        variant="body2"
                        style={{ paddingBottom: 10 }}
                      >
                        SAT
                      </Typography>
                      <Typography paragraph variant="caption">Critical Reading</Typography>
                      <div style={{ paddingTop: 30, paddingBottom: 35 }}>
                        <Slider
                          value={readingData}
                          marks={readingDataMarks}
                          valueLabelDisplay="auto"
                          aria-labelledby="range-slider"
                          step={40}
                          min={0}
                          max={800}
                          disabled
                        />
                      </div>
                      <Typography paragraph variant="caption">Math</Typography>
                      <div style={{ paddingTop: 30, paddingBottom: 35 }}>
                        <Slider
                          value={mathData}
                          marks={mathDataMarks}
                          valueLabelDisplay="auto"
                          aria-labelledby="range-slider"
                          step={40}
                          min={0}
                          max={800}
                          disabled
                        />
                      </div>
                      <Typography
                        variant="body2"
                        style={{ paddingBottom: 10 }}
                      >
                        ACT
                      </Typography>
                      <div style={{ paddingTop: 30, paddingBottom: 35 }}>
                        <Slider
                          value={ACTData}
                          marks={ACTDataMarks}
                          valueLabelDisplay="auto"
                          aria-labelledby="range-slider"
                          step={3}
                          min={0}
                          max={36}
                          disabled
                        />
                      </div>
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <AcceptanceRate school={school} alignHeader="center" />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default TestScores;
